import axios from 'axios';
import {
  CREATE_USER_MAPPING_UPLOAD_URL,
  USER_MAPPING_URL,
} from 'api/userMapping/constant';

export function performGetUserMapping(payload) {
  const { keyword, page, size } = payload;

  return axios
    .get(`${USER_MAPPING_URL}?keyword=${keyword}&page=${page}&size=${size}`)
    .then(response => {
      return Promise.resolve(response);
    })
    .catch(error => {
      return Promise.reject(error);
    });
}

export function performDeleteUserMapping(payload) {
  return axios
    .delete(`${USER_MAPPING_URL}/${payload}`)
    .then(response => {
      return Promise.resolve(response);
    })
    .catch(error => {
      return Promise.reject(error);
    });
}

export function performUpdateUserMapping(payload) {
  return axios
    .put(`${USER_MAPPING_URL}`, payload)
    .then(response => {
      return Promise.resolve(response);
    })
    .catch(error => {
      return Promise.reject(error);
    });
}

export function performCreateUserMapping(payload) {
  return axios
    .post(`${USER_MAPPING_URL}`, payload)
    .then(response => {
      return Promise.resolve(response);
    })
    .catch(error => {
      return Promise.reject(error);
    });
}

export function performCreateUserMappingUpload(payload) {
  return axios
    .post(`${CREATE_USER_MAPPING_UPLOAD_URL}`, payload, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    .then(response => {
      return Promise.resolve(response);
    })
    .catch(error => {
      return Promise.reject(error);
    });
}
